import script from "./InviteInformationTile.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteInformationTile.vue?vue&type=script&setup=true&lang=js"

export default script